// extracted by mini-css-extract-plugin
export default {"fondo":"Home_fondo__vcDeF","pokemonContainer":"Home_pokemonContainer__NzqNX","box":"Home_box__scSUH","filter":"Home_filter__v6Gep","label":"Home_label__AKCa5"};